module.exports = __webpack_public_path__ + "img/blossom.1d313789.png";